// extracted by mini-css-extract-plugin
export default {"pieContainer":"styles_pie-container__tbRkF","pieTitle":"styles_pie-title__e+7F+"};